export type OS = "ios" | "android" | "windows" | "macos" | "chromeos" | "linux";

export interface Step {
  titleKey: string;
  descKey: string;
}

export const STEPS: Record<OS, Step[]> = {
  ios: [
    { titleKey: "step_ios_1_title", descKey: "step_ios_1_desc" },
    { titleKey: "step_ios_2_title", descKey: "step_ios_2_desc" },
    { titleKey: "step_ios_3_title", descKey: "step_ios_3_desc" },
    { titleKey: "step_ios_4_title", descKey: "step_ios_4_desc" },
  ],
  android: [
    { titleKey: "step_android_1_title", descKey: "step_android_1_desc" },
    { titleKey: "step_android_2_title", descKey: "step_android_2_desc" },
    { titleKey: "step_android_3_title", descKey: "step_android_3_desc" },
    { titleKey: "step_android_4_title", descKey: "step_android_4_desc" },
  ],
  windows: [
    { titleKey: "step_windows_1_title", descKey: "step_windows_1_desc" },
    { titleKey: "step_windows_2_title", descKey: "step_windows_2_desc" },
    { titleKey: "step_windows_3_title", descKey: "step_windows_3_desc" },
    { titleKey: "step_windows_4_title", descKey: "step_windows_4_desc" },
  ],
  macos: [
    { titleKey: "step_macos_1_title", descKey: "step_macos_1_desc" },
    { titleKey: "step_macos_2_title", descKey: "step_macos_2_desc" },
    { titleKey: "step_macos_3_title", descKey: "step_macos_3_desc" },
    { titleKey: "step_macos_4_title", descKey: "step_macos_4_desc" },
  ],
  chromeos: [
    { titleKey: "step_chromeos_1_title", descKey: "step_chromeos_1_desc" },
    { titleKey: "step_chromeos_2_title", descKey: "step_chromeos_2_desc" },
    { titleKey: "step_chromeos_3_title", descKey: "step_chromeos_3_desc" },
    { titleKey: "step_chromeos_4_title", descKey: "step_chromeos_4_desc" },
  ],
  linux: [
    { titleKey: "step_linux_1_title", descKey: "step_linux_1_desc" },
    { titleKey: "step_linux_2_title", descKey: "step_linux_2_desc" },
    { titleKey: "step_linux_3_title", descKey: "step_linux_3_desc" },
    { titleKey: "step_linux_4_title", descKey: "step_linux_4_desc" },
  ],
};
